export const MAP_LANDMARKS_IMPORT_LANDMARK = "MAP_LANDMARKS_IMPORT_LANDMARK";
export const MAP_LANDMARKS_IMPORT_LANDMARK_RESPONSE = "MAP_LANDMARKS_IMPORT_LANDMARK_RESPONSE";
export const MAP_LANDMARKS_IMPORT_OPEN_DETAIL = "MAP_LANDMARKS_IMPORT_OPEN_DETAIL";
export const MAP_LANDMARKS_IMPORT_OPEN_EDIT = "MAP_LANDMARKS_IMPORT_OPEN_EDIT";